import { ArticleSearchParams } from '@obeta/models/lib/models/Search'
import { useArticlesSearchProvider } from './useArticleSearchProvider'

export const useFundings = (p: { searchParams?: ArticleSearchParams }) => {
  const { facets, isFetching } = useArticlesSearchProvider()

  return {
    fundings: facets.find((facet) => facet.name === 'eligibleFor')?.values || [],
    loading: isFetching,
  }
}
